import DefaultImg from "assets/images/landing/default.jpg";
import AutoServiceImg from "assets/images/landing/auto-service.jpg";
import OnlineSalesImg from "assets/images/landing/online-sales.jpg";
import HotelsImg from "assets/images/landing/hotels.jpg";
import BeautyImg from "assets/images/landing/beauty.jpg";

import { VideoSectionContent } from "pages/IbanOplata/VideoSection";

import { routes } from "routes/routes";

export const autoServiceMeta = {
  title: "Оплата по IBAN для автосервісів та СТО - IBAN oplata",
  description:
    "Приймайте оплату за реквізитами за ремонт авто чи продаж автозапчастин через IBAN oplata. Швидка оплата за посиланням або QR кодом у два кліки.",
  canonicalPath: `${routes.sip}${routes.autoService}`,
};

export const onlineSalesMeta = {
  title: "Оплата за реквізитами IBAN для онлайн-бізнесів - IBAN oplata",
  description:
    "Приймайте оплату через IBAN у вашому онлайн-магазині чи соцмережах. Створюйте посилання для клієнтів і приймайте оплату за реквізитами без помилок.",
  canonicalPath: `${routes.sip}${routes.onlineSales}`,
};

export const hotelsMeta = {
  title: "Оплата через IBAN для готелів та готельного бізнесу - IBAN oplata",
  description:
    "Оплата рахунку за реквізитами через IBAN oplata у два кліки. Швидка оплата на IBAN за проживання та додаткові послуги.",
  canonicalPath: `${routes.sip}${routes.hotels}`,
};

export const beautyMeta = {
  title: "Оплата за банківськими реквізитами для салонів краси - IBAN oplata",
  description:
    "Приймайте оплату по QR коду та за банківськими реквізитами без терміналів. Швидке створення платіжних посилань для ваших клієнтів.",
  canonicalPath: `${routes.sip}${routes.beauty}`,
};

export const defaultContent: VideoSectionContent = {
  name: "Оплата за реквізитами без помилок",
  title: "Виставляйте рахунки за 10 секунд",
  advantages: [
    {
      title: "Чесні умови без прихованих платежів:",
      description: "0% комісії з кожної оплати",
    },
    {
      title: "Зручне створення платежів:",
      description: "посилання або QR-код за лічені секунди",
    },
    {
      title: "Безпечна та миттєва оплата за реквізитами:",
      description: "не потребує даних картки",
    },
  ],
  videoCover: DefaultImg,
  videoUrl: "embed/8iJWFwf7Rrk",
  videoUrlMobile: "shorts/OaceTOD-9Go",
};

// TODO: remove after a/b test
export const abTestContent: VideoSectionContent = {
  name: "Оплата за реквізитами без помилок",
  title: "Отримуйте оплати без комісій",
  advantages: [
    {
      description: "Жодного еквайрингу, ПРРО чи складних реєстрацій",
    },
    {
      description: "Створення посилання чи QR-коду на оплату за секунди",
    },
    {
      description: "Клієнт здійснює платіж у два кліки",
    },
  ],
  videoCover: DefaultImg,
  videoUrl: "embed/8iJWFwf7Rrk",
  videoUrlMobile: "shorts/OaceTOD-9Go",
};

export const autoService: VideoSectionContent = {
  name: "Платіжне рішення для СТО",
  title: "IBAN oplata для автосервісів",
  advantages: [
    {
      title: "Гроші відразу на рахунку:",
      description:
        "0% комісії, збережіть сотні гривень на кожному великому чеку",
    },
    {
      title: "Швидка та зрозуміла оплата для клієнтів:",
      description: "посилання або QR-код — без плутанини з реквізитами",
    },
    {
      title: "Безпечно для сервісу й водіїв:",
      description: "оплата йде напряму на IBAN, без введення даних картки",
    },
  ],
  videoCover: AutoServiceImg,
  videoUrl: "embed/8iJWFwf7Rrk",
  videoUrlMobile: "shorts/OaceTOD-9Go",
};

export const onlineSales: VideoSectionContent = {
  name: "Розумне рішення для онлайн-бізнесів",
  title: "Приймайте оплати простіше з IBAN oplata",
  advantages: [
    {
      title: "Збільшуйте прибуток:",
      description:
        "0% комісії. Отримуйте повну суму на свій рахунок з кожного замовлення",
    },
    {
      title: "Швидка оплата:",
      description:
        "клієнт переходить за лінком і платить в 1 клік, а не відкладає оплату на пізніше",
    },
    {
      title: "Підвищуйте довіру:",
      description: "офіційне платіжне посилання замість номера картки в direct",
    },
  ],
  videoCover: OnlineSalesImg,
  videoUrl: "embed/8iJWFwf7Rrk",
  videoUrlMobile: "shorts/OaceTOD-9Go",
};

export const hotels: VideoSectionContent = {
  name: "IBAN oplata для готельного бізнесу",
  title: "Приймайте оплати простіше та швидше",
  advantages: [
    {
      title: "Економія бюджету:",
      description:
        "0% комісії сервісу. Отримуйте повну вартість проживання на свій рахунок",
    },
    {
      title: "Зручна оплата для гостей:",
      description:
        "посилання або QR-код, яке гість оплачує з телефону в 1 клік",
    },
    {
      title: "Підвищуйте довіру:",
      description:
        "офіційне платіжне посилання замість реквізитів в месенджерах чи email",
    },
  ],
  videoCover: HotelsImg,
  videoUrl: "embed/8iJWFwf7Rrk",
  videoUrlMobile: "shorts/OaceTOD-9Go",
};

export const beauty: VideoSectionContent = {
  name: "Платіжне рішення для салонів краси",
  title: "Приймайте оплати простіше з IBAN oplata",
  advantages: [
    {
      title: "Більше прибутку:",
      description:
        "0% комісії. Залишайте собі кожну гривню за стрижку, фарбування чи манікюр",
    },
    {
      title: "Швидка оплата:",
      description:
        "клієнт платить у 2 кліки за посиланням або QR-кодом, без черг і готівки",
    },
    {
      title: "Безпечно й професійно:",
      description: "без введення даних картки, без помилок у реквізитах",
    },
  ],
  videoCover: BeautyImg,
  videoUrl: "embed/8iJWFwf7Rrk",
  videoUrlMobile: "shorts/OaceTOD-9Go",
};
